"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteTotalWidget = void 0;
var react_1 = __importDefault(require("react"));
var QuoteTotalContext_1 = require("./QuoteTotalContext");
var styles = __importStar(require("./QuoteTotalWidget.css"));
var classnames_1 = __importDefault(require("classnames"));
var useQuoteLabel_1 = require("@CommonFrontend/Quote/useQuoteLabel");
var Types_1 = require("@CommonFrontendBackend/QuoteV2/Types");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var useQuoteCurrencyFormatter_1 = require("@CommonFrontendBackend/QuoteWidgets/useQuoteCurrencyFormatter");
var getDiscountAmountOffText_1 = require("@CommonFrontend/Quote/getDiscountAmountOffText");
var UserText = function (_a) {
    var _b = _a.strong, strong = _b === void 0 ? false : _b, _c = _a.large, large = _c === void 0 ? false : _c, children = _a.children;
    return react_1.default.createElement("span", { className: styles.userText({ strong: strong, large: large }) }, children);
};
var QuoteTotalWidget = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var attributes = _a.attributes, children = _a.children;
    var _j = (0, QuoteTotalContext_1.useQuoteTotalContext)(), total = _j.total, components = _j.components, price = _j.price, allDiscounts = _j.allDiscounts;
    var getLabel = (0, useQuoteLabel_1.useQuoteLabel)();
    var formatter = (0, useQuoteCurrencyFormatter_1.useQuoteCurrencyFormatter)();
    var taxes = (_c = (_b = price["one-off"]) === null || _b === void 0 ? void 0 : _b.taxes) !== null && _c !== void 0 ? _c : [];
    var selfDiscounts = (_e = (_d = price["one-off"]) === null || _d === void 0 ? void 0 : _d.discounts.filter(function (d) { return d.target === "self"; })) !== null && _e !== void 0 ? _e : [];
    var totalDiscounts = ((_f = allDiscounts["one-off"]) !== null && _f !== void 0 ? _f : []).reduce(function (acc, discount) { return acc + discount.amount; }, 0);
    var showDiscountsSection = selfDiscounts.length > 0 || (total.showTotalDiscounts && totalDiscounts > 0);
    return (react_1.default.createElement("div", __assign({}, attributes, { className: (0, classnames_1.default)(attributes.className, styles.wrapper) }),
        react_1.default.createElement("div", { contentEditable: false },
            components.OptionsMenu && (react_1.default.createElement("div", { "data-interactive-zone": true, className: styles.options },
                react_1.default.createElement(components.OptionsMenu, null))),
            react_1.default.createElement(kaleidoscope_1.Stack, { padding: "xl", gap: "l" },
                showDiscountsSection && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(kaleidoscope_1.Stack, { gap: "s" },
                        selfDiscounts.map(function (_a, discountIndex) {
                            var discount = _a.discount, amount = _a.amount;
                            return (react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", justify: "spaceBetween", key: discountIndex },
                                react_1.default.createElement(UserText, null, discount.type === "saved" ? discount.name : (0, getDiscountAmountOffText_1.getDiscountAmountOffText)(discount, formatter)),
                                react_1.default.createElement(UserText, null,
                                    "-",
                                    formatter.format(amount))));
                        }),
                        total.showTotalDiscounts && totalDiscounts && (react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", justify: "spaceBetween" },
                            react_1.default.createElement(UserText, null, "Total discounts"),
                            react_1.default.createElement(UserText, null,
                                "-",
                                formatter.format(totalDiscounts))))),
                    react_1.default.createElement(kaleidoscope_1.Separator, null))),
                total.showTotalExcludingTax && taxes.length > 0 && price["one-off"] && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(kaleidoscope_1.Stack, { gap: "s" },
                        react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", justify: "spaceBetween" },
                            react_1.default.createElement(UserText, null,
                                getLabel(Types_1.QuoteLabel.Total),
                                " ",
                                getLabel(Types_1.QuoteLabel.ExcludingTax)),
                            react_1.default.createElement(UserText, null, formatter.format(price["one-off"].quoted)))),
                    react_1.default.createElement(kaleidoscope_1.Separator, null))),
                total.showTaxes && taxes.length > 0 && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(kaleidoscope_1.Stack, { gap: "s" }, taxes.map(function (_a, taxIndex) {
                        var tax = _a.tax, amount = _a.amount;
                        return (react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", justify: "spaceBetween", key: taxIndex },
                            react_1.default.createElement(UserText, null, tax.name),
                            react_1.default.createElement(UserText, null, formatter.format(amount))));
                    })),
                    react_1.default.createElement(kaleidoscope_1.Separator, null))),
                react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", justify: "spaceBetween" },
                    react_1.default.createElement(UserText, { strong: true, large: true }, getLabel(Types_1.QuoteLabel.Total)),
                    react_1.default.createElement(UserText, { strong: true, large: true }, formatter.format((_h = (_g = price["one-off"]) === null || _g === void 0 ? void 0 : _g.billable) !== null && _h !== void 0 ? _h : 0))))),
        children));
};
exports.QuoteTotalWidget = QuoteTotalWidget;
